import React from 'react';
import { X } from 'lucide-react';
import ContactInfo from './ContactInfo';
import SocialLinks from './SocialLinks';

const ProfileModal = ({ profile, onClose }) => {
  if (!profile) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div 
        className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-3xl max-w-2xl w-full border border-slate-700/50 shadow-2xl animate-scaleIn"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-8">
          {/* Header */}
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center gap-4">
              <img 
                src={profile.photo} 
                alt={profile.name}
                className="w-24 h-24 rounded-full object-cover border-4 border-blue-600"
              />
              <div>
                <h2 className="text-3xl font-bold text-white mb-1">{profile.name}</h2>
                <p className="text-blue-400 font-medium text-lg">{profile.role}</p>
                <p className="text-slate-400 text-sm">{profile.company}</p>
              </div>
            </div>
            <button 
              onClick={onClose}
              className="p-2 hover:bg-slate-800 rounded-lg transition-colors"
              aria-label="Cerrar modal"
            >
              <X size={24} className="text-slate-400" />
            </button>
          </div>

          {/* Content Grid */}
          <div className="grid md:grid-cols-2 gap-6">
            <ContactInfo profile={profile} />
            <SocialLinks profile={profile} />
          </div>

          {/* Action Buttons */}
          <div className="mt-6 flex gap-3">
            <button className="flex-1 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white rounded-lg font-medium transition-all transform hover:scale-105">
              Enviar Mensaje
            </button>
            <button className="flex-1 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-lg font-medium transition-all">
              Descargar vCard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
